import { gql } from "@apollo/client";

export const GetTransformJunction = gql`
  query GetTransformJunction(
    $token: String!
    $customerID: ID!
    $junctionID: ID!
  ) {
    GetTransformJunction(
      token: $token
      customerID: $customerID
      junctionID: $junctionID
    ) {
      id
      name
      alias
      jType
      arms
      icon
      poles
      code
      address
      place
      state
      pin
      priority
      country
      isActive
      isTrafficSignal
      latitude
      longitude
      ticketStatus
      junctionStatus
      customerID
      companyID
      subsidiaryID
      siteID
      ldgrID
      vendorDetails {
        id
        desc
      }
    }
  }
`;

export const GetTransformTickets = gql`
  query GetTransformTickets(
    $token: String!
    $after: Cursor
    $first: Int
    $orderBy: AtsTicketsOrder
    $name: String
  ) {
    GetTransformTickets(
      token: $token
      after: $after
      first: $first
      orderBy: $orderBy
      where: { or: [{ ticketNoContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          ticketNo
          ticketDate
          reason
          type
          priority
          openRemarks
          lastRemarks
          poleNum
          status
          tableLevel
          resolvedDate
          closedDate
          closedDuration
          subsidiaryID
          companyID
          junctionID
          junction {
            id
            name
            alias
            jType
            arms
            icon
            poles
            code
            address
            vendorDetails {
              id
              desc
            }
          }
          vendorDetails {
            id
            desc
          }
          assignedUser {
            id
            name
          }
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const GetTransformTicketDetailsForFollowUp = gql`
  query GetTransformTicketDetailsForFollowUp(
    $token: String!
    $customerID: ID!
    $ticketID: ID!
    $junctionID: ID!
  ) {
    GetTransformTicketDetails(
      token: $token
      customerID: $customerID
      ticketID: $ticketID
      junctionID: $junctionID
    ) {
      id
      slNo
      status
      remarks
      imagesPath
      attendedDate
      companyID
      createdUserDetails {
        name
        empType
      }
      ticket {
        id
        ticketNo
        ticketDate
        vendorDetails {
          id
        }
      }
    }
  }
`;

export const GetTransformNearByJunctions = gql`
  query GetTransformNearByJunctions(
    $token: String!
    $longitude: Float!
    $latitude: Float!
    $after: Cursor
    $first: Int
    $orderBy: AtsJunctionsOrder
    $name: String
  ) {
    GetTransformNearByJunctions(
      token: $token
      longitude: $longitude
      latitude: $latitude
      after: $after
      first: $first
      orderBy: $orderBy
      where: { or: [{ nameContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          name
          icon
          code
          ticketStatus
          companyID
          icon
          latitude
          longitude
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const GetTransformEmpDetails = gql`
  query GetTransformEmpDetails($token: String!) {
    GetTransformEmpDetails(token: $token) {
      id
      kgid
      metalNo
      name
      empType
      address
      place
      state
      pin
      email
      mobile
      status
      gender
      rights
      lastAccessed
      firebaseID
      isLoginCreated
      authID
      customerID
      ldgrID
      companyID
      subsidiaryID
      siteID
    }
  }
`;
